export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const DATE_DISPLAY = 'LL'
export const DATE_DISPLAY_BIRTHDAY = 'L'
export const DATE_PICKERS_FORMAT = 'YYYY-MM-DD'
export const DATE_TOOLTIP_FORMAT = 'L'
export const DATE_FILTERS_FORMAT = 'DD/MM/YYYY'
export const DEPARTURE_DATE_RANGE_SHORT_FORMAT = 'MMMM YYYY'
export const DATE_KEY_FORMAT_CALENDAR = 'YYYY-MM-DD'
export const DEPARTURE_DATE_RANGE_SHORT_FORMAT_WITHOUT_YEAR = 'MMMM'
